module.exports = __webpack_public_path__ + "3e2d3fade0c7f7f1731f3e9a565d8fd5.svg";